
<template>
  <div class="documentup">
    <div class="top">
      <div class="back" @click="back">
        <i class="el-icon-arrow-left" /> 返回
      </div>
      <div class="path"><i class="el-icon-location" /> 文件库-上传文件</div>
    </div>
    <div class="documentcont">
      <div class="cont" style="margin-top: 0px">
        <div class="title">文件分类：</div>
        <div class="value">
          <!-- <el-input
            style="width: 350px"
            type="text"
            placeholder="填写会议标题"
            v-model="title"
          ></el-input> -->
          <el-select
            style="width: 350px"
            v-model="classify"
            @change="classifychange"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in classifylist"
              :key="item.gid"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
          <span class="classification" @click="addition = true">+新增分类</span>
        </div>
      </div>

      <div class="cont">
        <div class="title">文件名称：</div>
        <div class="value">
          <el-input
            type="text"
            placeholder="填写文件标题"
            v-model="title"
            maxlength="99"
            show-word-limit
            @change="titleChange"
          ></el-input>
        </div>
      </div>

      <div class="cont">
        <div class="title">文档上传：</div>
        <div class="value">
          <el-upload
            action="http://192.168.0.118:18091/self/upload"
            :on-change="handleChange"
            :auto-upload="false"
            drag
            multiple
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </div>
      </div>

      <div class="wire" />
      <div class="btnbox">
        <el-button
          size="small"
          style="width: 100px"
          type="primary"
          @click="open"
          v-loading="showLoading"
          >确认</el-button
        >
      </div>

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>

      <el-dialog title="新增分类" :visible.sync="addition" width="600px" center>
        <div class="classifybox">
          <div
            class="cont"
            v-for="(item, index) in classifylist"
            :key="item.gid"
          >
            <div class="titles">分类：</div>
            <div class="values">
              <el-input
                type="text"
                placeholder="填写事宜标题"
                v-model="item.name"
                size="small"
                @change="alterclassifyopen"
                @focus="classifyvalueFocus(index, item.name, item.gid)"
              >
              </el-input>
            </div>
            <i
              @click="opendelete(item.gid)"
              class="el-icon-remove-outline conticon"
            />
          </div>

          <div
            class="cont"
            v-for="(item, index) in addlist"
            :key="index + '分类'"
          >
            <div class="titles">分类：</div>
            <div class="values">
              <el-input
                type="text"
                placeholder="填写事宜标题"
                v-model="addlist[index]"
                maxlength="39"
                size="small"
                show-word-limit
                @focus="classifyvalueFocus(index)"
                @change="classifyvalueChange"
              >
              </el-input>
            </div>
            <i
              style="color: #009157"
              @click="openclassifyup(index)"
              class="el-icon-circle-plus-outline conticon"
            />
          </div>

          <div class="additionbtn">
            <el-button
              size="samll"
              type="primary"
              icon="el-icon-plus"
              style="width: 50%"
              @click="documentup"
              >添加</el-button
            >
          </div>
        </div>
        <div class="wires" />
        <!-- <div style="margin: auto;text-align: center;"> -->
        <!-- <el-button type="primary" size="small" style="width: 250px;" >确认</el-button> -->
        <!-- </div> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
export default {
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      title: "",
      dialogImageUrl: "",
      disabled: false,
      dialogVisible: false,
      documenturl: "",
      addition: false,
      classifyvalue: "",
      classifylist: "",
      classify: "",
      did: "",
      fileList: [],
      addlist: [],
      indexs: 0,
      altergid: 0,
      oldname: "",
      showLoading: false,
    };
  },
  mounted() {
    this.getclassify();
  },
  methods: {
    back() {
      this.$router.push({ name: "Document" });
    },
    titleChange(e) {
      this.title = e;
    },
    classifyvalueChange(e) {
      console.log(e, this.addlist, this.addlist[this.indexs]);
      this.addlist[this.indexs] = e;
      // this.classifyvalue = e;
    },
    classifyvalueFocus(i, name, gid) {
      console.log(i);
      this.indexs = i;
      this.oldname = name;
      this.altergid = gid;
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    classifychange(e) {
      console.log(e);
      this.did = e.gid;
      this.classify = e.name;
    },
    handleDownload(file) {
      console.log(file);
    },
    beforeAvatarUpload(file) {
      console.log("before", file);
    },
    documentup() {
      console.log(123);
      this.addlist.push("");
      console.log(this.addlist);
    },
    open() {
      console.log();
      this.$confirm("是否提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.UpLoad();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    async getclassify() {
      console.log(this.userInfo);
      try {
        const res = await getServerData(
          APIMAP.FILELIB,
          {
            pid: this.userInfo.platformid,
          },
          "get"
        );
        console.log("目录列表", res);
        res.sort((a, b) => {
          return b.gid - a.gid;
        });
        this.classifylist = res;
      } catch (e) {
        console.log(e);
      }
    },
    openclassifyup(index) {
      this.$confirm("是否提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.classifyUpLoad(index);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    opendelete(gid) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteclassify(gid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    alterclassifyopen(e) {
      console.log(this.classifylist[this.indexs].name);
      this.$confirm("是否修改?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.classifylist[this.indexs].name = e;
          this.alterclassify(e);
        })
        .catch(() => {
          this.classifylist[this.indexs].name = this.oldname;
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    async alterclassify(e) {
      var param = {
        name: e,
        type: "2",
        gid: this.altergid,
      };
      console.log(param);
      try {
        const res = await getServerData(APIMAP.FILELIB, param, "PUT");
        console.log(res);
        this.getclassify();
      } catch (e) {
        console.log(e);
      }
    },
    async deleteclassify(gid) {
      var param = {
        type: "2",
        gid: gid,
      };
      console.log(param);
      try {
        const res = await getServerData(APIMAP.FILELIB, param, "delete");
        console.log(res);
        this.getclassify();
      } catch (e) {
        console.log(e);
      }
    },
    async classifyUpLoad(index) {
      console.log(this.addlist[index]);
      try {
        const res = await getServerData(
          APIMAP.FILELIB,
          {
            name: this.addlist[index],
            pid: this.userInfo.platformid,
          },
          "post",
          0,
          true
        );
        console.log(res);
        this.getclassify();
        this.classifyvalue = "";
        this.addlist.splice(index, 1);
      } catch (e) {
        console.log(e);
      }
    },
    async UpLoad() {
      this.showLoading = true;
      try {
        const res = await getServerData(
          APIMAP.UPLOAD,
          {
            file: this.documenturl,
            pid: this.userInfo.platformid,
            type: "3",
            directory: this.classify,
            uid: this.userInfo.gid,
            uploader: this.userInfo.realname,
            did: this.did,
            fileName: this.title,
          },
          "post",
          0,
          true
        );
        console.log(res);
        this.showLoading = false;
        this.$router.push({ name: "Document" });
      } catch (e) {
        console.log(e);
        this.showLoading = false;
      }
    },
    async handleChange(file, filelist) {
      console.log(file, filelist, this.userInfo);
      this.fileList = file.raw.name;
      this.documenturl = file.raw;
    },
  },
};
</script>

<style lang="less" scoped>
.documentup {
  background-color: #f5f6fd;
  padding: 17px 19px;
  height: calc(100vh - 100px);
  width: 100%;
  .top {
    height: 49px;
    background: white;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #99a9ba;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    .back {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
      cursor: pointer;
    }
    .path {
      margin-left: 19px;
      margin-top: 15px;
      display: inline-block;
    }
  }
  .documentcont {
    height: calc(100vh - 195px);
    margin-top: 9px;
    background: white;
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Regular;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    box-shadow: 0px 6px 14px 0px rgba(127, 170, 217, 0.12);
    padding: 18px 20px;
    .classifybox {
      height: 500px;
      overflow: auto;
      .additionbtn {
        margin-top: 30px;
        text-align: center;
        width: 100%;
        text-align: center;
      }
    }
    .cont {
      overflow: hidden;
      margin-bottom: 25px;
      font-size: 14px;
      .title {
        float: left;
        width: 80px;
        margin-right: 10px;
        position: relative;
        color: #394259;
        top: 9px;
        font-size: 14px;
        font-weight: 900;
      }
      .titles {
        width: 50px;
        float: left;
        margin-right: 10px;
        position: relative;
        color: #394259;
        top: 6px;
        font-size: 14px;
      }
      .value {
        float: left;
        width: calc(100% - 100px);
        .classification {
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Regular;
          text-decoration: underline;
          color: #009157;
          margin-left: 20px;
          cursor: pointer;
        }
        .personnel {
          padding: 15px 10px;
          height: 83px;
          border: 1px solid rgba(201, 209, 212, 0.7);
          border-radius: 4px;
          position: relative;
          .allbtn {
            position: absolute;
            right: 15px;
            bottom: 10px;
          }
        }
        .minute {
          display: inline-block;
          position: relative;
          left: -25px;
        }
      }
      .values {
        float: left;
        width: calc(100% - 100px);
      }
      .conticon {
        font-size: 20px;
        position: relative;
        top: 6px;
        margin-left: 10px;
      }
    }
    .wire {
      position: absolute;
      width: calc(100% - 40px);
      bottom: 70px;
      right: 20px;
      border: 1px solid rgba(226, 229, 236, 0.6);
    }
    .wires {
      margin-top: 20px;
      border: 1px solid rgba(226, 229, 236, 0.6);
      margin-bottom: 30px;
    }
    .btnbox {
      float: right;
      margin-top: 30px;
      position: absolute;
      bottom: 18px;
      right: 20px;
    }
  }
}
</style>